import React, { useEffect, useContext, useState } from "react";
import { useLocation } from "react-router-dom";
import MyNavLink from "../MyNavLink";
import style from "./style.less";
import { FunctionalConfig } from "@/config";
import { LanguageContext } from "@/data/LanguageProvider";
import { PersistContext } from "@/data/PersistProvider";
import { SendCMD } from "@/utils/HTTPRequest";

function getTabClass(linkPath, locationPath) {
  return linkPath === locationPath ? `${style.tab_item} ${style.tab_active}` : style.tab_item;
}

function getTabNavClass(linkPath, locationPath, itemName) {
  let activeClassName = "tab_" + itemName + "_active";
  let className = "tab_" + itemName;
  return linkPath === locationPath
    ? `${style.tab_item} ${style[activeClassName]}`
    : `${style.tab_item} ${style[className]}`;
}

const BottomNav = (props) => {
  let location = useLocation();
  const { getLanguage, langText } = useContext(LanguageContext);
  const { getPersist, setPersist } = useContext(PersistContext);
  const [freecashReward, setFreecashReward] = useState(false);
  const [freecasheNotEnter, setFreecashNotEnter] = useState(false);

  useEffect(() => {
    if (!getPersist("dataLoaded")) {
      return;
    }
    if (!getPersist("user_info")) {
      return;
    }
    SendCMD("inviteFriendsGetInfo", { token: getPersist("user_info").token }).then((res) => {
      if (!res.status) {
        console.log(res.errdesc);
      } else {
        console.log(res.info);
        setPersist("freecashInfo", res.info);
        if (res.info.list && res.info.list.length > 0) {
          for (let i = 0; i < res.info.list.length; i++) {
            if (res.info.list[i].total_charge >= res.info.cfg.charge_limit) {
              setFreecashReward(true);
              if (res.info.reward_log
                && res.info.reward_log[res.info.list[i].rid]
                && res.info.reward_log[res.info.list[i].rid].charge
                && res.info.reward_log[res.info.list[i].rid].charge == 1
              ) {
                setFreecashReward(false);
              }
              if (freecashReward) {
                break;
              }
            }
            if (res.info.list[i].total_bet >= res.info.cfg.bet_limit) {
              setFreecashReward(true);
              if (res.info.reward_log
                && res.info.reward_log[res.info.list[i].rid]
                && res.info.reward_log[res.info.list[i].rid].bet
                && res.info.reward_log[res.info.list[i].rid].bet == 1
              ) {
                setFreecashReward(false);
              }
              if (freecashReward) {
                break;
              }
            }
          }
        }
      }
    });
  }, [getPersist("freecashInfo")]);

  useEffect(() => {
    setFreecashNotEnter(!getPersist("freecashOpenDay") || getPersist("freecashOpenDay") != new Date().getDay());
  }, [getPersist("freecashOpenDay")]);

  console.log("location.pathname:", location.pathname);
  return (
    <div class={style.container} style={getLanguage() == "bem" && { paddingBottom: "0.5rem" }}>
      <div style={{
        position: "absolute",
        height: "100%",
        width: "100%",
        background: "linear-gradient(to top, #000000 10%, rgba(255, 255, 255, 0) 90%)",
        zIndex: "1"
      }}></div>
      <MyNavLink to="/home" style={{ zIndex: "2" }}>
        <div class={getTabNavClass("/home", location.pathname, "home")} />
        <span class={style.tab_text} style={location.pathname == "/home" && { color: "rgb(60, 190, 25)" }} >{langText("home_btn_home")}</span>
      </MyNavLink>
      <MyNavLink to="/deposit" style={{ zIndex: "2" }}>
        <div class={getTabNavClass("/deposit", location.pathname, "deposit")} />
        <span class={style.tab_text} style={location.pathname == "/deposit" && { color: "rgb(60, 190, 25)" }} >{langText("home_btn_deposit")}</span>
      </MyNavLink>
      <MyNavLink to="/MakeMoney" style={{ zIndex: "2" }}>
        <div class={getTabNavClass("/MakeMoney", location.pathname, "MakeMoney")} />
        <span class={style.tab_text} style={location.pathname == "/MakeMoney" && { color: "rgb(60, 190, 25)" }} >
          {langText("makemoney_title_1")}
          {/* {(freecashReward || freecasheNotEnter) && (<img class={style.hongdian} src={require("@/assets/images/home/class_icon/hongdian.png").default} />)} */}
        </span>
      </MyNavLink>
      <MyNavLink to="/withdraw" style={{ zIndex: "2" }}>
        <div class={getTabNavClass("/withdraw", location.pathname, "withdraw")} />
        <span class={style.tab_text} style={location.pathname == "/withdraw" && { color: "rgb(60, 190, 25)" }}>{langText("home_btn_withdraw")}</span>
      </MyNavLink>
      <MyNavLink to="/profile" style={{ zIndex: "2" }}>
        <div class={getTabNavClass("/profile", location.pathname, "profile")} />
        <span class={style.tab_text} style={location.pathname == "/profile" && { color: "rgb(60, 190, 25)" }} >{langText("home_btn_profile")}</span>
      </MyNavLink>
    </div>
  );
};

export default BottomNav;